/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthToken } from '../models/auth-token';
import { BookingDto } from '../models/booking-dto';
import { canSubscribeUserToTowerGroup } from '../fn/partner-api/can-subscribe-user-to-tower-group';
import { CanSubscribeUserToTowerGroup$Params } from '../fn/partner-api/can-subscribe-user-to-tower-group';
import { closePartnerBookingBox } from '../fn/partner-api/close-partner-booking-box';
import { ClosePartnerBookingBox$Params } from '../fn/partner-api/close-partner-booking-box';
import { createBooking1 } from '../fn/partner-api/create-booking-1';
import { CreateBooking1$Params } from '../fn/partner-api/create-booking-1';
import { createPartnerSubscription } from '../fn/partner-api/create-partner-subscription';
import { CreatePartnerSubscription$Params } from '../fn/partner-api/create-partner-subscription';
import { createPartnerUser } from '../fn/partner-api/create-partner-user';
import { CreatePartnerUser$Params } from '../fn/partner-api/create-partner-user';
import { deletePartnerUser } from '../fn/partner-api/delete-partner-user';
import { DeletePartnerUser$Params } from '../fn/partner-api/delete-partner-user';
import { getPartnerBooking } from '../fn/partner-api/get-partner-booking';
import { GetPartnerBooking$Params } from '../fn/partner-api/get-partner-booking';
import { getPartnerBookingAmount } from '../fn/partner-api/get-partner-booking-amount';
import { GetPartnerBookingAmount$Params } from '../fn/partner-api/get-partner-booking-amount';
import { getPartnerBookings } from '../fn/partner-api/get-partner-bookings';
import { GetPartnerBookings$Params } from '../fn/partner-api/get-partner-bookings';
import { getPartnerSubscription } from '../fn/partner-api/get-partner-subscription';
import { GetPartnerSubscription$Params } from '../fn/partner-api/get-partner-subscription';
import { getPartnerSubscriptions } from '../fn/partner-api/get-partner-subscriptions';
import { GetPartnerSubscriptions$Params } from '../fn/partner-api/get-partner-subscriptions';
import { getPartnerTowerGroup } from '../fn/partner-api/get-partner-tower-group';
import { GetPartnerTowerGroup$Params } from '../fn/partner-api/get-partner-tower-group';
import { getPartnerTowerGroups } from '../fn/partner-api/get-partner-tower-groups';
import { GetPartnerTowerGroups$Params } from '../fn/partner-api/get-partner-tower-groups';
import { getPartnerUser } from '../fn/partner-api/get-partner-user';
import { GetPartnerUser$Params } from '../fn/partner-api/get-partner-user';
import { getPartnerUserByEmail } from '../fn/partner-api/get-partner-user-by-email';
import { GetPartnerUserByEmail$Params } from '../fn/partner-api/get-partner-user-by-email';
import { getPartnerUsers } from '../fn/partner-api/get-partner-users';
import { GetPartnerUsers$Params } from '../fn/partner-api/get-partner-users';
import { getTowerGroupImage2 } from '../fn/partner-api/get-tower-group-image-2';
import { GetTowerGroupImage2$Params } from '../fn/partner-api/get-tower-group-image-2';
import { logout } from '../fn/partner-api/logout';
import { Logout$Params } from '../fn/partner-api/logout';
import { openPartnerBookingBox } from '../fn/partner-api/open-partner-booking-box';
import { OpenPartnerBookingBox$Params } from '../fn/partner-api/open-partner-booking-box';
import { partnerAuth } from '../fn/partner-api/partner-auth';
import { PartnerAuth$Params } from '../fn/partner-api/partner-auth';
import { partnerRefreshToken } from '../fn/partner-api/partner-refresh-token';
import { PartnerRefreshToken$Params } from '../fn/partner-api/partner-refresh-token';
import { PartnerUserDto } from '../models/partner-user-dto';
import { PaymentAmountDto } from '../models/payment-amount-dto';
import { SimpleValue } from '../models/simple-value';
import { SubscriptionDto } from '../models/subscription-dto';
import { terminatePartnerBooking } from '../fn/partner-api/terminate-partner-booking';
import { TerminatePartnerBooking$Params } from '../fn/partner-api/terminate-partner-booking';
import { TowerGroupDto } from '../models/tower-group-dto';
import { updatePartnerBookingPin } from '../fn/partner-api/update-partner-booking-pin';
import { UpdatePartnerBookingPin$Params } from '../fn/partner-api/update-partner-booking-pin';
import { updatePartnerUser } from '../fn/partner-api/update-partner-user';
import { UpdatePartnerUser$Params } from '../fn/partner-api/update-partner-user';

@Injectable({ providedIn: 'root' })
export class PartnerApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPartnerUser()` */
  static readonly GetPartnerUserPath = '/api/partner/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerUser$Response(params: GetPartnerUser$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerUserDto>> {
    return getPartnerUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPartnerUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerUser(params: GetPartnerUser$Params, context?: HttpContext): Observable<PartnerUserDto> {
    return this.getPartnerUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnerUserDto>): PartnerUserDto => r.body)
    );
  }

  /** Path part for operation `updatePartnerUser()` */
  static readonly UpdatePartnerUserPath = '/api/partner/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePartnerUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePartnerUser$Response(params: UpdatePartnerUser$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerUserDto>> {
    return updatePartnerUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePartnerUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePartnerUser(params: UpdatePartnerUser$Params, context?: HttpContext): Observable<PartnerUserDto> {
    return this.updatePartnerUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnerUserDto>): PartnerUserDto => r.body)
    );
  }

  /** Path part for operation `deletePartnerUser()` */
  static readonly DeletePartnerUserPath = '/api/partner/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePartnerUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePartnerUser$Response(params: DeletePartnerUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePartnerUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePartnerUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePartnerUser(params: DeletePartnerUser$Params, context?: HttpContext): Observable<void> {
    return this.deletePartnerUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updatePartnerBookingPin()` */
  static readonly UpdatePartnerBookingPinPath = '/api/partner/bookings/{id}/updatePin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePartnerBookingPin()` instead.
   *
   * This method doesn't expect any request body.
   */
  updatePartnerBookingPin$Response(params: UpdatePartnerBookingPin$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingDto>> {
    return updatePartnerBookingPin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePartnerBookingPin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updatePartnerBookingPin(params: UpdatePartnerBookingPin$Params, context?: HttpContext): Observable<BookingDto> {
    return this.updatePartnerBookingPin$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingDto>): BookingDto => r.body)
    );
  }

  /** Path part for operation `getPartnerUsers()` */
  static readonly GetPartnerUsersPath = '/api/partner/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerUsers$Response(params?: GetPartnerUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PartnerUserDto>>> {
    return getPartnerUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPartnerUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerUsers(params?: GetPartnerUsers$Params, context?: HttpContext): Observable<Array<PartnerUserDto>> {
    return this.getPartnerUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PartnerUserDto>>): Array<PartnerUserDto> => r.body)
    );
  }

  /** Path part for operation `createPartnerUser()` */
  static readonly CreatePartnerUserPath = '/api/partner/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPartnerUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartnerUser$Response(params: CreatePartnerUser$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerUserDto>> {
    return createPartnerUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPartnerUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartnerUser(params: CreatePartnerUser$Params, context?: HttpContext): Observable<PartnerUserDto> {
    return this.createPartnerUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnerUserDto>): PartnerUserDto => r.body)
    );
  }

  /** Path part for operation `getPartnerUserByEmail()` */
  static readonly GetPartnerUserByEmailPath = '/api/partner/users/get_by_email';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerUserByEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPartnerUserByEmail$Response(params: GetPartnerUserByEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerUserDto>> {
    return getPartnerUserByEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPartnerUserByEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPartnerUserByEmail(params: GetPartnerUserByEmail$Params, context?: HttpContext): Observable<PartnerUserDto> {
    return this.getPartnerUserByEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnerUserDto>): PartnerUserDto => r.body)
    );
  }

  /** Path part for operation `getPartnerSubscriptions()` */
  static readonly GetPartnerSubscriptionsPath = '/api/partner/subscriptions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerSubscriptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerSubscriptions$Response(params?: GetPartnerSubscriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubscriptionDto>>> {
    return getPartnerSubscriptions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPartnerSubscriptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerSubscriptions(params?: GetPartnerSubscriptions$Params, context?: HttpContext): Observable<Array<SubscriptionDto>> {
    return this.getPartnerSubscriptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubscriptionDto>>): Array<SubscriptionDto> => r.body)
    );
  }

  /** Path part for operation `createPartnerSubscription()` */
  static readonly CreatePartnerSubscriptionPath = '/api/partner/subscriptions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPartnerSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartnerSubscription$Response(params: CreatePartnerSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    return createPartnerSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPartnerSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartnerSubscription(params: CreatePartnerSubscription$Params, context?: HttpContext): Observable<SubscriptionDto> {
    return this.createPartnerSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /** Path part for operation `getPartnerBookings()` */
  static readonly GetPartnerBookingsPath = '/api/partner/bookings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerBookings$Response(params?: GetPartnerBookings$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BookingDto>>> {
    return getPartnerBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPartnerBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerBookings(params?: GetPartnerBookings$Params, context?: HttpContext): Observable<Array<BookingDto>> {
    return this.getPartnerBookings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BookingDto>>): Array<BookingDto> => r.body)
    );
  }

  /** Path part for operation `createBooking1()` */
  static readonly CreateBooking1Path = '/api/partner/bookings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBooking1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBooking1$Response(params: CreateBooking1$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingDto>> {
    return createBooking1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBooking1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBooking1(params: CreateBooking1$Params, context?: HttpContext): Observable<BookingDto> {
    return this.createBooking1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingDto>): BookingDto => r.body)
    );
  }

  /** Path part for operation `terminatePartnerBooking()` */
  static readonly TerminatePartnerBookingPath = '/api/partner/bookings/{id}/terminate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `terminatePartnerBooking()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  terminatePartnerBooking$Response(params: TerminatePartnerBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingDto>> {
    return terminatePartnerBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `terminatePartnerBooking$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  terminatePartnerBooking(params: TerminatePartnerBooking$Params, context?: HttpContext): Observable<BookingDto> {
    return this.terminatePartnerBooking$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingDto>): BookingDto => r.body)
    );
  }

  /** Path part for operation `openPartnerBookingBox()` */
  static readonly OpenPartnerBookingBoxPath = '/api/partner/bookings/{id}/open';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `openPartnerBookingBox()` instead.
   *
   * This method doesn't expect any request body.
   */
  openPartnerBookingBox$Response(params: OpenPartnerBookingBox$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return openPartnerBookingBox(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `openPartnerBookingBox$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  openPartnerBookingBox(params: OpenPartnerBookingBox$Params, context?: HttpContext): Observable<void> {
    return this.openPartnerBookingBox$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `closePartnerBookingBox()` */
  static readonly ClosePartnerBookingBoxPath = '/api/partner/bookings/{id}/close';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `closePartnerBookingBox()` instead.
   *
   * This method doesn't expect any request body.
   */
  closePartnerBookingBox$Response(params: ClosePartnerBookingBox$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return closePartnerBookingBox(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `closePartnerBookingBox$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  closePartnerBookingBox(params: ClosePartnerBookingBox$Params, context?: HttpContext): Observable<void> {
    return this.closePartnerBookingBox$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `partnerAuth()` */
  static readonly PartnerAuthPath = '/api/partner/auth';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerAuth()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnerAuth$Response(params: PartnerAuth$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthToken>> {
    return partnerAuth(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerAuth$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnerAuth(params: PartnerAuth$Params, context?: HttpContext): Observable<AuthToken> {
    return this.partnerAuth$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthToken>): AuthToken => r.body)
    );
  }

  /** Path part for operation `getPartnerTowerGroups()` */
  static readonly GetPartnerTowerGroupsPath = '/api/partner/towers/groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerTowerGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerTowerGroups$Response(params?: GetPartnerTowerGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TowerGroupDto>>> {
    return getPartnerTowerGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPartnerTowerGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerTowerGroups(params?: GetPartnerTowerGroups$Params, context?: HttpContext): Observable<Array<TowerGroupDto>> {
    return this.getPartnerTowerGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TowerGroupDto>>): Array<TowerGroupDto> => r.body)
    );
  }

  /** Path part for operation `getPartnerTowerGroup()` */
  static readonly GetPartnerTowerGroupPath = '/api/partner/towers/groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerTowerGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerTowerGroup$Response(params: GetPartnerTowerGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerGroupDto>> {
    return getPartnerTowerGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPartnerTowerGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerTowerGroup(params: GetPartnerTowerGroup$Params, context?: HttpContext): Observable<TowerGroupDto> {
    return this.getPartnerTowerGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerGroupDto>): TowerGroupDto => r.body)
    );
  }

  /** Path part for operation `getTowerGroupImage2()` */
  static readonly GetTowerGroupImage2Path = '/api/partner/towers/groups/{id}/image/{size}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTowerGroupImage2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerGroupImage2$Response(params: GetTowerGroupImage2$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getTowerGroupImage2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTowerGroupImage2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerGroupImage2(params: GetTowerGroupImage2$Params, context?: HttpContext): Observable<string> {
    return this.getTowerGroupImage2$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `canSubscribeUserToTowerGroup()` */
  static readonly CanSubscribeUserToTowerGroupPath = '/api/partner/towers/groups/{id}/cansubscribe/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `canSubscribeUserToTowerGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  canSubscribeUserToTowerGroup$Response(params: CanSubscribeUserToTowerGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleValue>> {
    return canSubscribeUserToTowerGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `canSubscribeUserToTowerGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  canSubscribeUserToTowerGroup(params: CanSubscribeUserToTowerGroup$Params, context?: HttpContext): Observable<SimpleValue> {
    return this.canSubscribeUserToTowerGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleValue>): SimpleValue => r.body)
    );
  }

  /** Path part for operation `getPartnerSubscription()` */
  static readonly GetPartnerSubscriptionPath = '/api/partner/subscriptions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerSubscription$Response(params: GetPartnerSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    return getPartnerSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPartnerSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerSubscription(params: GetPartnerSubscription$Params, context?: HttpContext): Observable<SubscriptionDto> {
    return this.getPartnerSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /** Path part for operation `getPartnerBooking()` */
  static readonly GetPartnerBookingPath = '/api/partner/bookings/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerBooking()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerBooking$Response(params: GetPartnerBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingDto>> {
    return getPartnerBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPartnerBooking$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerBooking(params: GetPartnerBooking$Params, context?: HttpContext): Observable<BookingDto> {
    return this.getPartnerBooking$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingDto>): BookingDto => r.body)
    );
  }

  /** Path part for operation `getPartnerBookingAmount()` */
  static readonly GetPartnerBookingAmountPath = '/api/partner/bookings/{id}/amount';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerBookingAmount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerBookingAmount$Response(params: GetPartnerBookingAmount$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentAmountDto>> {
    return getPartnerBookingAmount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPartnerBookingAmount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerBookingAmount(params: GetPartnerBookingAmount$Params, context?: HttpContext): Observable<PaymentAmountDto> {
    return this.getPartnerBookingAmount$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentAmountDto>): PaymentAmountDto => r.body)
    );
  }

  /** Path part for operation `partnerRefreshToken()` */
  static readonly PartnerRefreshTokenPath = '/api/partner/auth/refresh';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerRefreshToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerRefreshToken$Response(params?: PartnerRefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthToken>> {
    return partnerRefreshToken(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerRefreshToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerRefreshToken(params?: PartnerRefreshToken$Params, context?: HttpContext): Observable<AuthToken> {
    return this.partnerRefreshToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthToken>): AuthToken => r.body)
    );
  }

  /** Path part for operation `logout()` */
  static readonly LogoutPath = '/api/partner/auth/logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logout()` instead.
   *
   * This method doesn't expect any request body.
   */
  logout$Response(params?: Logout$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return logout(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  logout(params?: Logout$Params, context?: HttpContext): Observable<void> {
    return this.logout$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
